import '../../../style.css';

import React, { useEffect, useRef, useState } from 'react';

import Animations from '../../../Animations';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';

const Description = ({ slug, dynamicContent }) => {
    const sectionRef = useRef(null);
    const [contentLoaded, setContentLoaded] = useState(false);
    const [imageErrors, setImageErrors] = useState({ img1: false, img2: false, img3: false });

    const handleIntersection = () => {
        setContentLoaded(true);
    };

    const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

    useEffect(() => {
        // Reset image errors when slug changes
        setImageErrors({ img1: false, img2: false, img3: false });
    }, [slug]); // Dependency array, this effect will run when 'slug' changes

    const handleImageError = (imgKey) => {
        setImageErrors(prev => ({ ...prev, [imgKey]: true }));
    };

    const renderDescriptionList = (descriptionText) => {
        if (!descriptionText) return null;

        const sentences = descriptionText.split('. ').filter(Boolean);
        return (
            <ul>
                {sentences.map((sentence, index) => {
                    const [title, content] = sentence.split(': ');
                    return (
                        <li className="section-text" key={index}><strong>{title}:</strong> {content}</li>
                    );
                })}
            </ul>
        );
    };

    return (
        <div ref={sectionRef} className={`loading-container${contentLoaded ? '' : ' loading-spinner-container'}`}>
            {contentLoaded ? (
                <section className={`description${isVisible ? ' fade-in-observer' : ''}`} id="description">
                    <div className="description-content section-content">
                        <p className="section-subtitle">{dynamicContent.DescNameObj}</p>
                        <h2 className="h3 section-title">{dynamicContent.DescTitleObj}</h2>
                        <p className="section-text">{dynamicContent.DescriptionObj}</p>
                    </div>
                    <div className="devices">
                        <Animations type="fadeInUp">
                            <div className="image">
                                <img src={`/assets/images/portfolio/description/devices-${slug}.png`} alt="The product being displayed across mobile and desktop devices" />
                            </div>
                        </Animations>
                    </div>
                    <div className="description-content section-content">
                        <p className="section-subtitle">{dynamicContent.DescNameCha}</p>
                        <h2 className="h3 section-title">{dynamicContent.DescTitleCha}</h2>
                        <p className="section-text">{dynamicContent.DescriptionCha}</p>
                    </div>
                    <div className="mobile">
                        {!imageErrors.img1 && (
                            <div className="col">
                                <Animations type="fadeInUp" delay="0s" key="img1">
                                    <img
                                        src={`/assets/images/portfolio/description/devices-${slug}-1.png`}
                                        alt="The product being displayed across mobile and desktop devices"
                                        onError={() => handleImageError('img1')}
                                    />
                                </Animations>
                            </div>
                        )}
                        {!imageErrors.img2 && (
                            <div className="col">
                                <Animations type="fadeInUp" delay=".6s" key="img2">
                                    <img
                                        src={`/assets/images/portfolio/description/devices-${slug}-2.png`}
                                        alt="The product being displayed across mobile and desktop devices"
                                        onError={() => handleImageError('img2')}
                                    />
                                </Animations>
                            </div>
                        )}
                        {!imageErrors.img3 && (
                            <div className="col">
                                <Animations type="fadeInUp" delay="1.2s" key="img3">
                                    <img
                                        src={`/assets/images/portfolio/description/devices-${slug}-3.png`}
                                        alt="The product being displayed across mobile and desktop devices"
                                        onError={() => handleImageError('img3')}
                                    />
                                </Animations>
                            </div>
                        )}
                    </div>
                    <div className="description-content section-content">
                        <p className="section-subtitle">{dynamicContent.DescNameSol}</p>
                        <h2 className="h3 section-title">{dynamicContent.DescTitleSol}</h2>
                        {renderDescriptionList(dynamicContent.DescriptionSol)}
                    </div>
                </section>
            ) : (
                <div className="observer_spinner"></div>
            )}
        </div>
    );
};

export default Description;
